import React, { useRef, useState, useEffect } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { getPromotionMainColor, i18nIntl, isDesktop } from '../../lib/ep';

import ActionButton from '../../components/builder/ActionButton';
import SaveButton from '../../components/builder/SaveButton';
import Spinner from '../../components/builder/Spinner';

import FloatingLayerPublic from '../../components/front/FloatingLayerPublic';
import PromoColsWrapper from '../../components/front/PromoColsWrapper';

import ScratchCanvas from '../../components/games/ScratchCanvas';

import ScratchInstructionsCanvas from '../../components/canvas/ScratchInstructionsCanvas';

const standard_board_size = 600;	// px
const img_path = `${window.cdn_url}img/games_gui/scratch/`;

const FinishButton = (props) => {
	const is_builder = props.is_builder;
	const is_auto = props?.is_auto ?? false;
	const response = props.response;
	const display_next_participations = props.display_next_participations;
	const next_participation = props.next_participation;

	let _classes = ['game_ctas'];
	if(!is_auto && !isDesktop()) {
		return (
			<div class={_classes.join(" ")} style={{paddingBlockStart:'2em'}}>
				<div class="flex_button gui_big_button register_flex">
					<ActionButton
						_href={response.url}
						_fullclass=""
					>Continue</ActionButton>
				</div>

				{(response.spt > 0 && display_next_participations) && (
					<p class="next_participation">
						<FormattedMessage id="Try again in {time}" values={{ time:next_participation }} />
					</p>
				)}
			</div>
		)
	}

	_classes.push('is_overlapped');

	if(is_auto) {
		return (
			<div class={_classes.join(" ")}>
				<div id="overlapped_button" class="flex_button">
					<Spinner color={props.main_color} force_bg={true} />
				</div>
			</div>
		)
	}

	return (
		<div class={_classes.join(" ")}>
			<div id="overlapped_button" class="flex_button">
				{(!is_builder) && (
					<ActionButton
						_href={response.url}
						_fullclass=""
					>Continue</ActionButton>
				)}

				{(is_builder && props.resetGame != undefined) && (
					<ActionButton
						onClick={props.resetGame}
						_fullclass=""
					>Reset game</ActionButton>
				)}
			</div>

			{(response.spt > 0 && display_next_participations) && (
				<p class="next_participation">
					<FormattedMessage id="Try again in {time}" values={{ time:next_participation }} />
				</p>
			)}
		</div>
	)
};

const ScratchStage = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const is_builder = props?.is_builder ?? false;
	const is_editing = (is_builder && props.is_editing != undefined) ? props.is_editing : false;
	const is_ghosting = (is_editing && props.is_ghosting != undefined) ? props.is_ghosting : false;
	const show_grid = (is_editing && props.show_grid != undefined) ? props.show_grid : false;

	const [ displayFirstTry, setDisplayFirstTry ] = useState(!is_builder);
	const [ finished, setFinished ] = useState(false);
	const [ finished_auto, setFinishedAuto ] = useState(false);
	const [ response, setResponse ] = useState(props?.userInfo ?? {});
	const [ given_prize, setGivenPrize ] = useState(props?.given_prize ?? null);
	const [ canvas_size, setCanvasSize ] = useState(null);
	const [ participating, setParticipating ] = useState(false);
	const running = useRef(true);
	const currentuid = useRef();

	const stage = props?.stage?.Stage ?? false;
	if(stage === false) return null;

	const page_introduction = (stage.main_description != undefined && stage.main_description != "") ? stage.main_description : null;
	const auto_transition = stage?.auto_transition || false;

	const promo = props.promotion.Promotion;

	const only_cover = (is_builder && props?.only_cover) || false;

	const getCanvasSize = (num_tries) => {
		const container = document.querySelector('.gui_game_parent');
		while(num_tries > 0 && container == undefined) getCanvasSize(num_tries - 1);
		if(container != undefined) {
			const calculated_size = Math.min(container.clientWidth, document.querySelector('.flex_cols').clientWidth);
			if(calculated_size > 250) return calculated_size;
		}
		return standard_board_size;
	};

	useEffect(() => {
		setTimeout(() => {
			setCanvasSize(getCanvasSize(3));
		}, 100);

		const _container = document.querySelector('.main_flex_wrapper');
		_container.classList.remove('is_game');
		_container.classList.add('is_new_game');
	}, []);

	if(only_cover) {
		const img_url = (stage?.scratch_cover != undefined) ? stage.full_scratch_cover : `${img_path}tapper.jpg`;

		return (
			<PromoColsWrapper main_image={stage?.main_image && stage.full_main_image} main_video={stage.main_video} main_description={page_introduction}>
				<div class="gui_game_parent">
					<img src={`${window.cdn_url}img/blank_1x1.png`} width="100%" alt="" />
					<div class="game_bg_preview is_fullscreen relative_to_container" style={{backgroundImage:`url(${img_url})`}} />
				</div>
			</PromoColsWrapper>
		)
	}

	const participate = (cb) => {
		if(is_builder || participating) return;
		setParticipating(true);
		$.post(`/promotions/participate/${props.promotion.Promotion.id}/${stage.id}`, { spin:true, ticket:props.ticket }, (res) => {
			if(res.status) {
				let parts = res.url.split('/');
				currentuid.current = parts[parts.length - 2];
				setGivenPrize(res.spt);

				setResponse(res);
				if(displayFirstTry) setDisplayFirstTry(false);
				if(cb != undefined) cb();
			} else {
				if(res.url != undefined) {
					window.location.href = res.url;
				}
			}
			setParticipating(false);
		}, 'JSON');
	};

	const getPrize = (id) => {
		if(id == 0 || id == undefined) return { id:0 };
		const prize = props.prizes.find((p) => p.id == id);
		return prize;
	};

	const resetGame = () => {
		if(!is_builder) return;
		if (props.scratch.area == undefined) {
			props.updateArea(false);
		}
		else {
			props.updateArea({...props.scratch.area});
		}
		running.current = true;
		setFinished(false);
	};

	useEffect(() => {
		setGivenPrize(props.given_prize);
	}, [props.given_prize]);
	
	const display_next_participations = (!is_builder && response.next_participation !== true && (stage.participation_frequency == undefined || stage.participation_frequency != 'total')) ? true : false;

	const time_to_next_participation = EPDateDuration(EPDateDiff(response.next_participation));
	const next_participation = (display_next_participations) ? time_to_next_participation.humanize() : "0 secs";
	const prize = getPrize(given_prize);
	const main_color = getPromotionMainColor(promo);

	let scratch = { id:0 };
	if(is_builder) {
		scratch = props.scratch;
	} else {
		if(stage.scratch) {
			let prize_info = stage.scratch.find((p) => p.id == prize.id);
			if(prize_info) scratch = prize_info;
		}
	}

	const finishGame = () => {
		running.current = false;

		setFinished(true);
		if(auto_transition && response.url != undefined) {
			const delay = (prize.id == '0') ? 2 : 5;
			setFinishedAuto(true);
			setTimeout(() => {
				window.location.href = response.url;
			}, (delay * 1000));
		}
	};

	return (
		<PromoColsWrapper main_image={stage?.main_image && stage.full_main_image} main_video={stage.main_video} main_description={page_introduction}>
			<div class="gui_game_parent">
				<img src={`${window.cdn_url}img/blank_1x1.png`} width="100%" alt="" />

				<ScratchCanvas
					canvas_size={canvas_size}
					onFinish={finishGame}
					prizeType={prize}
					promotion={promo}
					scratch={scratch}
					stage={stage}
					userInfo={response}
					is_builder={is_builder}
					is_editing={is_editing}
					is_ghosting={is_ghosting}
					show_grid={show_grid}
					updateArea={props.updateArea}
				/>
			</div>

			{(finished) && (
				<FinishButton
					is_auto={finished_auto}
					is_builder={is_builder}
					main_color={main_color}
					resetGame={resetGame}
					response={response}
					display_next_participations={display_next_participations}
					next_participation={next_participation}
				/>
			)}

			{(displayFirstTry) && (
				<FloatingLayerPublic
					only_contents={true}
					pm={props.promotion.Promotion}
					title={`<h1>${i18n("How to play?")}</h1>`}
					enable_close={false}
					backButton={(e, cb) => participate(cb)}
				>
					<div class="gui_canvas_instructions">
						<div class="cta_and_info">
							<div class="gui_not_in_top_small flex_button gui_big_button register_flex">
								<SaveButton
									_fullclass=""
									onClick={(e, cb) => participate(cb)}
								>Continue</SaveButton>
							</div>
						</div>

						<div class="gui_text_align_center">
							<ScratchInstructionsCanvas
								container='.gui_floating_layer_react .contents'
								info_container=".cta_and_info"
								padding_container='.gui_canvas_instructions'
								main_color={main_color}
							/>
						</div>
					</div>
				</FloatingLayerPublic>
			)}
		</PromoColsWrapper>
	);
}

export default injectIntl(ScratchStage);